[
  {
    "id": "humans",
    "name": "Humans",
    "description": "The kingdom's people, centered on Dawnmere and the fortress of Ironwatch.",
    "allied": true,
    "homeLocationId": "ironwatch_fortress",
    "leader": "The Crown of Crownreach, through its Court Chamberlain",
    "internalConflict": "A court that will not treat with an unknown villager until the Chamberlain vouches for one.",
    "submissionRequirement": "Master-level Diplomacy and the Crown's full trust — then it will place its armies in your hands.",
    "resolvedKnowledge": "humans_subjected"
  },
  {
    "id": "high_elves",
    "name": "High Elves",
    "description": "An old and distant realm centered on Moonspire, slow to trust and slower to forget.",
    "allied": true,
    "homeLocationId": "starbow_academy",
    "leader": "The Elven Court of Moonspire",
    "internalConflict": "A court that receives no stranger the Starbow instructors have not first learned to remember.",
    "submissionRequirement": "Master-level Diplomacy and the Court's trust — offer fealty and it will offer its strength.",
    "resolvedKnowledge": "high_elves_subjected"
  },
  {
    "id": "dwarves",
    "name": "Dwarves",
    "description": "Mountain smiths and siege-breakers of Stonehall, who have fought giants for longer than the kingdom has existed.",
    "allied": true,
    "homeLocationId": "stonehall",
    "leader": "Thane Durn of Stonehall",
    "internalConflict": "Stonehall and the forge-city of Emberforge have not spoken civilly in a generation, over a debt of iron neither will name first. No Thane can march the clans until the feud is settled.",
    "submissionRequirement": "Settle the Stonehall–Emberforge feud, earn the Thane's trust, and hold Master Diplomacy.",
    "resolvedKnowledge": "dwarves_subjected"
  },
  {
    "id": "wood_elves",
    "name": "Wood Elves",
    "description": "Rangers of Greenveil, the only scouts who can reliably find a Dark Elf before it finds them.",
    "allied": true,
    "homeLocationId": "greenveil",
    "leader": "Warden Sylvaine of Greenveil",
    "internalConflict": "The rangers are split: the elders of Elderroot Grove would let the wider world burn and keep the forest whole, while Thornwatch's scouts want to march. Neither side will move while the other holds.",
    "submissionRequirement": "Win the argument at Elderroot Grove, earn Sylvaine's trust, and hold Master Diplomacy.",
    "resolvedKnowledge": "wood_elves_subjected"
  },
  {
    "id": "spellcasters",
    "name": "Spellcasters",
    "description": "The orders of the Sevenfold Tower: ritualists who unmake bindings, and fire-handlers who make wounds permanent.",
    "allied": true,
    "homeLocationId": "sevenfold_tower",
    "leader": "Archmagister Vaeloth of the Sevenfold Tower",
    "internalConflict": "The Glass Library's ritualists and the Rift Observatory's fire-handlers each believe the other's discipline is what will doom the world. The Tower cannot commit to a war it cannot agree how to fight.",
    "submissionRequirement": "Reconcile the two orders' reading of the threat, earn Vaeloth's trust, and hold Master Diplomacy.",
    "resolvedKnowledge": "spellcasters_subjected"
  },
  {
    "id": "good_spirits",
    "name": "Good Spirits",
    "description": "The watchers of the Whispering Lake, who contest the dead and the possessed on ground the living cannot reach.",
    "allied": true,
    "homeLocationId": "whispering_lake",
    "leader": "The Pale Sister of the Whispering Lake",
    "internalConflict": "The shades in the Hall of Ancestors want the Necromancer's dead unmade to the last bone; the living wardens want them laid to rest with mercy. The Sister will not act until the house speaks with one voice.",
    "submissionRequirement": "Reconcile the ancestors and the wardens, earn the Sister's trust, and hold Master Diplomacy.",
    "resolvedKnowledge": "good_spirits_subjected"
  },
  {
    "id": "nomads",
    "name": "Nomads",
    "description": "The Seven Banners of the steppe: horse-clans who owe fealty to no crown and read the open country the way a scholar reads a page.",
    "allied": true,
    "homeLocationId": "camp_seven_banners",
    "leader": "Khan Aytolga of the Seven Banners",
    "internalConflict": "Seven clans, and no single Khan the other six will follow. The banners have gathered at Windroad Market to argue a succession, and an army that cannot choose a leader cannot lend one.",
    "submissionRequirement": "Broker the succession of the Seven Banners, earn Aytolga's trust, and hold Master Diplomacy.",
    "resolvedKnowledge": "nomads_subjected"
  },
  {
    "id": "orcs",
    "name": "Orcs",
    "description": "Raiders pressing against the kingdom's borders from the wastes beyond.",
    "allied": false,
    "homeLocationId": "blacktooth_wastes",
    "leader": "Warchief Gorruk of the Blacktooth",
    "weakness": "Momentum. Orcs are only dangerous while they believe they are winning; break the warchief and the war-camp scatters.",
    "resolution": "Defeat the Blacktooth muster, or expose that the Necromancer's servants opened their rift and armed them — shown their strings, the clans turn on the hand that pulled them rather than on the kingdom.",
    "resolvedKnowledge": "resolved_orcs"
  },
  {
    "id": "dragons",
    "name": "Dragons",
    "description": "Solitary and armoured, descending from Cinderpeak when something below is worth burning.",
    "allied": false,
    "homeLocationId": "cinderpeak",
    "leader": "Vharethyx, the Ember of Cinderpeak",
    "weakness": "Massed archery. Scale turns steel and fire means nothing to a thing made of fire, but the High Elves have trained for centuries to put an arrow through a wingbeat.",
    "resolution": "Bring Vharethyx down over Cinderpeak — or, knowing dragons serve no one, strike a cold bargain that keeps the Ember out of the Necromancer's war entirely.",
    "resolvedKnowledge": "resolved_dragons"
  },
  {
    "id": "trolls",
    "name": "Trolls",
    "description": "The hungry things of the Mire, which do not stay wounded.",
    "allied": false,
    "homeLocationId": "mire_hunger",
    "leader": "The Mother of the Mire",
    "weakness": "Fire. A troll grows back every wound but a burned one; the Flame Guard exist to make wounds permanent.",
    "resolution": "Burn out the Mire — or, since the trolls only ever hunted to be fed, let the Nomads treat with the Mother and turn a famine into a border rather than a battle.",
    "resolvedKnowledge": "resolved_trolls"
  },
  {
    "id": "giants",
    "name": "Giants",
    "description": "The slow walkers of Colossus Vale, who have never needed to learn caution.",
    "allied": false,
    "homeLocationId": "colossus_vale",
    "leader": "Jarnsmiter, Eldest of Colossus Vale",
    "weakness": "The dwarves. Giants are armoured in sheer size and have never had to learn caution; dwarves have fought them at the knees since before the kingdom existed.",
    "resolution": "Break the warband in Colossus Vale — or reopen the old dwarf-giant peace the two peoples once kept, and end a feud instead of a people.",
    "resolvedKnowledge": "resolved_giants"
  },
  {
    "id": "undead",
    "name": "Undead",
    "description": "The Necromancer's standing army, raised and held upright by anchors driven into old ground.",
    "allied": false,
    "homeLocationId": "ashen_necropolis",
    "leader": "The Necropolis Anchor of Ashen ground",
    "weakness": "Holy force and the unmaking of anchors. Steel scratches the bound dead; Spirit Wardens contest them directly and Ritual Mages break the anchors that hold them upright.",
    "resolution": "There is no army to spare here, only bodies to release: throw down the great anchor at the Ashen Necropolis and the dead it holds up lie down. The merciful resolution and the military one are the same act.",
    "resolvedKnowledge": "resolved_undead"
  },
  {
    "id": "dark_elves",
    "name": "Dark Elves",
    "description": "The Nightweb's killers, who fight only from concealment and rarely fight twice the same way.",
    "allied": false,
    "homeLocationId": "nightweb_underrealm",
    "leader": "Matron Vess of the Nightweb",
    "weakness": "Being found. You cannot fight what you cannot see; Wood Elf Pathfinders are the only scouts who reliably drag a Dark Elf into the light.",
    "resolution": "Break the Nightweb by fighting them where they can be seen — or let the Wood Elves treat with their estranged kin, who kill for coin and coercion and can be bought out of the Necromancer's service.",
    "resolvedKnowledge": "resolved_dark_elves"
  },
  {
    "id": "demon_spirits",
    "name": "Demon Spirits",
    "description": "What comes through the Shattered Veil, for as long as the tear stays open.",
    "allied": false,
    "homeLocationId": "shattered_veil",
    "leader": "Whatever holds the tear open on the far side",
    "weakness": "The binding itself. Killing what crawls through means nothing while the Veil remains; Ritual Mages unmake the tear and Spirit Wardens hold the ground while they work.",
    "resolution": "Do not fight the endless — seal the Shattered Veil at its anchor. Close the tear and there is nothing left to defeat.",
    "resolvedKnowledge": "resolved_demon_spirits"
  },
  {
    "id": "necromancer",
    "name": "The Necromancer",
    "description": "The maker of the ritual that will extinguish the sun on the five hundred and twelfth day, walled up in the Ebon Citadel behind an army and a gate.",
    "allied": false,
    "homeLocationId": "ebon_citadel",
    "leader": "The Necromancer",
    "weakness": "Unknown. Every stronghold cleared and every anchor unmade is one less thing between the world and the citadel — the reckoning itself belongs to a later day.",
    "resolution": "Reach the Ebon Citadel. What is done there is the whole of the war that comes after.",
    "resolvedKnowledge": "reached_ebon_citadel"
  }
]
